import { useState, useEffect } from 'react'
import { FiSearch, FiFilter } from 'react-icons/fi'
import { getEvents } from '../services/api'
import EventCard from '../components/EventCard'
import { categoryList } from '../helpers/category'

export default function HomePage() {
    const [events, setEvents] = useState([])
    const [loading, setLoading] = useState(true)
    const [category, setCategory] = useState('')
    const [search, setSearch] = useState('')
    const [featured, setFeatured] = useState([])

    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0)
        }, 0);
    }, [])

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            loadEvents()
        }, 300)
        return () => clearTimeout(timeoutId)
    }, [category, search])

    const loadEvents = async () => {
        setLoading(true)
        try {
            const params = { per_page: 20 }
            if (category) params.category = category
            if (search) params.search = search

            const response = await getEvents(params)
            setEvents(response.data.data || response.data)

            // Get featured events
            const featuredResponse = await getEvents({ featured: true })
            setFeatured(featuredResponse.data.data || featuredResponse.data)
        } catch (error) {
            console.error('Failed to load events', error)
        } finally {
            setLoading(false)
        }
    }

    const handleSearch = (e) => {
        e.preventDefault()
        loadEvents()
    }

    const categories = [
        { value: '', text: window.t('vsichki_sabitiya') },
        ...categoryList
    ]

    return (
        <div className="min-h-screen pt-16">
            {/* Hero Section */}
            <section className="relative py-20 overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-primary-900/50 via-gray-950 to-accent-900/30 bg-[blue]" />

                <div
                    className="absolute inset-0"
                    style={{
                        backgroundImage: 'url(homehero.jpg)',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        filter: 'blur(3px) contrast(1.5)',
                        opacity: '0.35'
                    }}
                >
                    <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary-500/20 rounded-full blur-3xl" />
                    <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-accent-500/20 rounded-full blur-3xl" />
                </div>

                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">

                    <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
                        <span className="relative inline-block">
                            <span className="absolute inset-0 bg-blue-500 rounded-md -skew-x-3 opacity-80 blur-[30px] mix-blend-multiply"></span>

                            <span className="relative gradient-text">
                                {window.t('izzhiveyte')} {window.t('magiyata_na')}
                            </span>
                        </span>

                        <br />

                        <span>{window.t('zabavleniyata_na_zhivo')}</span>
                    </h1>

                    <p className="text-xl text-gray-200 max-w-2xl mx-auto mb-8" style={{ textShadow: '1px 1px 0 rgba(255,255,255,0.15)' }}>
                        {window.t('rezervirayte_bileti_za_filmi_t')}
                    </p>

                    {/* Search */}
                    <form onSubmit={handleSearch} className="max-w-xl mx-auto">
                        <div className="relative">
                            <FiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 w-5 h-5" />
                            <input
                                type="text"
                                placeholder={window.t('tarsene_na_sabitiya')}
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                className="input pl-12 pr-32"
                            />
                            <button type="submit" className="absolute right-2 top-1/2 -translate-y-1/2 btn-primary py-2 px-4">
                                {window.t('tarsene')}
                            </button>
                        </div>
                    </form>
                </div>
            </section>

            {/* Featured Events */}
            {featured.length > 0 && !search && (
                <section className="py-12">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <h2 className="text-2xl font-bold text-white mb-6">{window.t('preporachani_sabitiya')}</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {featured.slice(0, 3).map(event => (
                                <EventCard key={event.id} event={event} />
                            ))}
                        </div>
                    </div>
                </section>
            )}

            {/* All Events */}
            <section className="py-12">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex flex-col md:flex-row md:items-center justify-between mb-8">
                        <h2 className="text-2xl font-bold text-white mb-4 md:mb-0">{window.t('vsichki_sabitiya')}</h2>

                        {/* Category Filter */}
                        <div className="flex gap-2 pb-2 md:pb-0">
                            {/*
                            {categories.map(cat => (
                                <button
                                    key={cat.value}
                                    onClick={() => setCategory(cat.value)}
                                    className={`px-4 pt-[0.4rem] pb-[0.5rem] rounded-full text-sm font-medium transition-all whitespace-nowrap ${category === cat.value
                                        ? 'bg-primary-500 text-gray-900'
                                        : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
                                        }`}
                                >
                                    {window.t(cat.text)}
                                </button>
                            ))}
                            */}

                            <select
                                value={category}
                                onChange={e => setCategory(e.target.value)}
                                className="input"
                            >
                                {categories.map((x) => (
                                    <option key={x.value} value={x.value}>
                                        {window.t(x.text)}
                                    </option>
                                ))}
                            </select>

                        </div>
                    </div>

                    {loading ? (
                        <div className="flex justify-center py-20">
                            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500"></div>
                        </div>
                    ) : events.length === 0 ? (
                        <div className="text-center py-20">
                            <p className="text-gray-400 text-lg">{window.t('nyama_namereni_sabitiya')}</p>
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                            {events.map(event => (
                                <EventCard key={event.id} event={event} />
                            ))}
                        </div>
                    )}
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-20 bg-gradient-to-r from-primary-900/50 to-accent-900/50 relative overflow-hidden">

                <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary-500/20 rounded-full blur-3xl" />
                <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-accent-500/20 rounded-full blur-3xl" />

                <div className="max-w-4xl mx-auto px-4 text-center z-10 relative">
                    <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight">
                        <span className="relative inline-block">
                            <span className="absolute inset-0 bg-blue-800 rounded-md -skew-x-3 opacity-80 blur-[30px] mix-blend-multiply"></span>

                            <span className="relative gradient-text">
                                {window.t('nikoga_ne_propuskayte_shou')}
                            </span>
                        </span>
                    </h2>

                    <p className="text-gray-900 mb-8" style={{ textShadow: '1px 1px 0 rgba(0,0,0,0.15)' }}>
                        {window.t('abonirayte_se_za_nashiya_byule')}
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
                        <input
                            type="email"
                            placeholder={window.t('vavedete_vashiya_imeyl')}
                            className="input flex-1"
                        />
                        <button className="btn-primary">{window.t('abonirane')}</button>
                    </div>
                </div>

                <div className="absolute inset-0 bg-gradient-to-br from-primary-900/50 via-gray-900/50 to-accent-900/30 bg-[blue] opacity-50 blur-[5px] contrast-[2.5]" />

                <div
                    className="absolute inset-0 bg-gradient-to-br from-primary-900/50 via-gray-950 to-accent-900/30 bg-[blue] opacity-50"
                    style={{
                        backgroundImage: 'url(subscribe.jpg)',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        filter: 'blur(3px) contrast(1.5)',
                        opacity: '0.35'
                    }}
                />

            </section>
        </div>
    )
}
